module.exports = {
  LAST_VISIT_DATE: ['0-3 Months Ago', '3-6 Months Ago', '6-12 Months Ago', 'Over 12 Months Ago'],
};
